import { LanguageInput } from "../input/LanguageInput";
import { PHPResponse } from "../PHPResponse";
import { PHPAdress, PHPAdresses } from "../PHPAdress";
import { PHPRequest } from "../PHPRequest";
import { EmailInput } from "./UserSignUpRequest";



export class UserLogoutRequest extends PHPRequest<PHPAdress,LanguageInput,PHPResponse>
{
  static readonly ADRESS = PHPAdresses.USER_LOGOUT;

  constructor(){ super( UserLogoutRequest.ADRESS ); }

}
